import React from "react";
import styles from "./messagesLink.scss"

export const MessagesIcon = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.messagesIcon}>
        <g clip-path="url(#clip0_4402_14964)">
            <g clip-path="url(#clip1_4402_14964)">
                <g clip-path="url(#clip2_4402_14964)">
                    <path d="M10.3125 17.1875C9.94783 17.1875 9.59809 17.0426 9.34023 16.7848C9.08237 16.5269 8.9375 16.1772 8.9375 15.8125V8.9375C8.9375 8.57283 9.08237 8.22309 9.34023 7.96523C9.59809 7.70737 9.94783 7.5625 10.3125 7.5625H19.9375C20.3022 7.5625 20.6519 7.70737 20.9098 7.96523C21.1676 8.22309 21.3125 8.57283 21.3125 8.9375V15.8125C21.3125 16.1772 21.1676 16.5269 20.9098 16.7848C20.6519 17.0426 20.3022 17.1875 19.9375 17.1875H18.5625V21.3125L14.4375 17.1875H10.3125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.1875 11.6875L3.4375 14.4375V10.3125H2.0625C1.69783 10.3125 1.34809 10.1676 1.09023 9.90977C0.832366 9.65191 0.6875 9.30217 0.6875 8.9375V2.0625C0.6875 1.69783 0.832366 1.34809 1.09023 1.09023C1.34809 0.832366 1.69783 0.6875 2.0625 0.6875H11.6875C12.0522 0.6875 12.4019 0.832366 12.6598 1.09023C12.9176 1.34809 13.0625 1.69783 13.0625 2.0625V4.8125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4402_14964">
                <rect width="22" height="22" fill="white" />
            </clipPath>
            <clipPath id="clip1_4402_14964">
                <rect width="22" height="22" fill="white" />
            </clipPath>
            <clipPath id="clip2_4402_14964">
                <rect width="22" height="22" fill="white" />
            </clipPath>
        </defs>
    </svg>

)



// WEBPACK FOOTER //
// ./src/components/Header/MessagesLink/MessagesIcon.tsx